module.exports = __webpack_public_path__ + "fonts/CosmopolitanScript-Regular.c5f78344.ttf";